import UnitAlarmForm                from 'scripts/defa/units/view-unit-alarm-form';
import ControlModule                from 'scripts/poppet/control-module';
import template                     from './controlGeneralAlarmSwitchesView.jst.html';
import ControlFollowMainAlarmView   from './follow-main-alarm/view-control-follow-main-alarm';
import ControlGeneralAlarmInputView from './general-alarm-input/view-control-general-alarm-input-view';

const selectors = {
	gpaiMessageRegion     : '[data-region=gpai-message]',
	generalAlarmSwitch    : '[data-region=general-alarm-input-switch]',
	followMainAlarmSwitch : '[data-region=follow-main-alarm-switch]',
	closeButton           : '[data-click=gpai-close]'
};

export const ControlGpaiView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	ui: {
		close : selectors.closeButton
	},
	
	regions: {
		gpaiMessage           : selectors.gpaiMessageRegion,
		generalAlarmSwitch    : selectors.generalAlarmSwitch,
		followMainAlarmSwitch : selectors.followMainAlarmSwitch,
	},
	
	events: {
		'click @ui.close'  : 'onClickClose', // super
	},
	
	className: function () {
		return this._getClassName( 'control-general-alarm-input' );
	},
	
	onClickClose: function(){
		this.trigger('close', this)
	},
	
	onDomRefresh() {
		let unitAlarmForm = new UnitAlarmForm( _.extend( this.options, {
			model: this.options.settingsHome,
		} ) );
		this.showChildView( 'gpaiMessage', unitAlarmForm );
		
		let followMainAlarmView = new ControlFollowMainAlarmView ( _.extend( this.options, {
			model: this.model.followMainAlarmModel,
		}));
		this.showChildView( 'followMainAlarmSwitch', followMainAlarmView );
		
		let generalAlarmInputView = new ControlGeneralAlarmInputView ( _.extend( this.options, {
			model: this.model.generalAlarmInputModel,
		}));
		this.showChildView( 'generalAlarmSwitch', generalAlarmInputView );
		
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
});

export default  ControlGpaiView;
